import { defineStore } from 'pinia'
import { ref, Ref, unref } from 'vue'

const TOKEN = 'new-dispatcher-sector'

import { DispatcherSector } from '@/new-services/types/dispatcher-sectors'

import { useLocalStorage } from 'vue-composable'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export const useNewDispatcherStore = defineStore('new-dispatcher-store', () => {
    const dispatcherSectorIds = ref([24]) as Ref<number[]>
    const isWithoutSectorId = ref(false)
    const dispatcherSectors = ref([]) as Ref<DispatcherSector[]>
    const WITH_NULLABLE_ROUTES = [
        '/new-dispatcher/monitoring',
        '/new-dispatcher/deliveries',
        '/new-dispatcher/takes',
    ]
    const WITH_CUSTOM_ROUTES = ['/new-dispatcher/takes']
    const WITHOUT_SECTORS = ['/new-dispatcher/couriers']
    const MULTI_SELECT = ['/new-dispatcher/takes']

    const validation$ = useVuelidate(
        {
            dispatcherSectorIds: { required },
        },
        { dispatcherSectorIds }
    )

    function initialize() {
        const { storage } = useLocalStorage(TOKEN)

        if (storage.value) {
            let storage_sectors = undefined as DispatcherSector[] | undefined

            if (typeof storage.value === 'object') {
                storage_sectors = storage.value
            }

            if (typeof storage.value === 'string' && storage.value !== 'undefined') {
                storage_sectors = JSON.parse(storage.value)
            }

            if (storage_sectors) {
                dispatcherSectorIds.value = storage_sectors.map(
                    (sector: { id: number }) => sector.id
                )
                dispatcherSectors.value = [...storage_sectors]

                return
            }
        }
    }

    function syncWithLocalStorage() {
        const { storage } = useLocalStorage(TOKEN)

        if (dispatcherSectors.value && dispatcherSectors.value.length) {
            storage.value = JSON.stringify(unref(dispatcherSectors.value))
        } else {
            storage.value = ''
        }
    }

    return {
        isWithoutSectorId,
        dispatcherSectorIds,
        dispatcherSectors,
        validation$,
        initialize,
        syncWithLocalStorage,
        WITH_NULLABLE_ROUTES,
        WITHOUT_SECTORS,
        MULTI_SELECT,
        WITH_CUSTOM_ROUTES,
    }
})
